<template>
  <div class="home-main-buttons-3" :class="$store.state.theme">
    <div class="btns is-uppercase">
      <div v-for="b in visibleButtons" :key="b.name" class="bt" @click="b.action">
        <img :src="b.img" />
        <p>{{ $t(b.name) }}</p>
      </div>
    </div>
    <!-- <div v-if="nButtons < buttons.length">
      <div class="button is-rounded is-white more-btn" style="padding: 6px" @click="toggleShowAll">
        <i v-if="showAll" class="fa fa-minus-circle fa-lg" />
        <i v-else class="fa fa-chevron-circle-down fa-lg" />
      </div>
    </div> -->
    <div style="height: 22px" />

    <div v-if="showAll" class="all">
      <div class="btns is-uppercase">
        <div v-for="b in invisibleButtons" :key="b.name" class="bt" @click="b.action">
          <img :src="b.img" />
          <p>{{ $t(b.name) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeMainButtons3",
  data() {
    return {
      nButtons: 3, // was 5, update on window resize event
      showAll: false,
      buttons: [
        {
          name: "home2.eat",
          img: "/img/home2/home_eat.png", // "/img/home2/eat.svg",
          action: this.goToEat,
          show: true,
        },
        {
          name: "home2.essentials",
          img: "/img/home2/home_mart.png", // "/img/home2/mart.svg",
          action: this.goToMart,
          show: true, //this.$store.getters.getNearestMartID, // won't show if none nearby
        },
        {
          name: "home2.ride",
          img: "/img/home2/home_ride.png", // "/img/home2/ride.svg",
          action: this.goToRide, //this.gotoDelay("ride"),
          show: true,
        },
        // {
        //   name: "home2.shop",
        //   img: "/img/home2/home_shop.png", // "/img/home2/shop.svg",
        //   action: this.goToShops, //this.gotoDelay("shop?tab=shops"),
        //   show: true,
        // },
        {
          name: "home2.send",
          img: "/img/home2/home_send.png", // "/img/home2/logistics.svg",
          // action: this.openLogisticsForm,
          action: this.goToSend,
          show: false, // turned off on 6 May 2023
        },
        {
          name: "home2.help",
          img: "/img/home2/home_help.png", // "/img/home2/help.svg",
          action: this.openHelp,
          show: true,
        },
      ],
      buttonsBangkok: [
        {
          name: "home2.eat",
          img: "/img/home2/home_eat.png", // "/img/home2/eat.svg",
          action: this.goToEat,
          show: true,
        },
        {
          name: "home2.ride",
          img: "/img/home2/home_ride.png", // "/img/home2/ride.svg",
          action: this.goToRide, //this.gotoDelay("ride"),
          show: true,
        },
        {
          name: "home2.help",
          img: "/img/home2/home_help.png", // "/img/home2/help.svg",
          action: this.openHelp,
          show: true,
        },
      ],
      buttonsLisbon: [
        {
          name: "Mart",
          img: "/img/home2/sol_mart_icon.png",
          //   action: () =>
          //     this.gotoDelay("/shop/d3eeb490-3e20-11ec-b488-42c0a08ef57d"),
          //   show: true,
          action: this.goToMart,
          show: this.$store.getters.getNearestMartID,
        },
        {
          name: "Wine",
          img: "/img/home2/sol_wine_icon.png",
          action: () =>
            this.gotoDelay("/shop/271c342c-3f21-11ec-b3e8-1ab1f82ca901"),
          show: true,
        },
        {
          name: "Art",
          img: "/img/home2/sol_art_icon.png",
          action: () =>
            this.gotoDelay("/shop/1e76cafe-3efe-11ec-9003-c29e59d04c01"),
          show: true,
        },
        {
          name: "Ride",
          img: "/img/home2/sol_ride_icon.png",
          action: () => this.gotoDelay("/ride"),
          show: true,
        },
        {
          name: "home2.help",
          img: "/img/home2/sol_help_icon.png", // chat with sumner
          action: this.openHelp,
          show: true,
        },
      ],
      geos: [
        // default show all buttons, enabled
        {
          geo: "Bangkok",
          buttons: ["ride", "eat", "mart"],
          disabled: ["eat", "mart"],
        },
        {
          geo: "Chiang Mai",
          buttons: [
            "ride",
            "eat",
            "mart",
            "shop",
            "trip",
            "ship",
            "service",
            "help",
          ],
          disabled: ["service"],
        },
        {
          geo: "Lisbon",
          buttons: ["sol_wine", "sol_mart", "sol_art"],
        },
      ],
    };
  },
  computed: {
    geoButtons() {
      var geo = this.$store.state.region;
      if (geo === "Lisbon") return this.buttonsLisbon;
      if (geo === "Bangkok") return this.buttonsBangkok;
      return this.buttons;
    },
    visibleButtons() {
      //   if (this.showAll) return this.filteredButtons;
      return this.filteredButtons.slice(0, this.nButtons);
    },
    invisibleButtons() {
      var n = this.filteredButtons.length;
      return this.filteredButtons.slice(this.nButtons, n);
    },
    filteredButtons() {
      //   return this.buttons.filter((b) => b.show);
      return this.geoButtons.filter((b) => b.show);
    },
  },
  mounted() {
    this.updateNButtons();
    window.addEventListener("resize", () => this.updateNButtons());
  },
  deactivated() {
    this.showAll = false;
  },
  methods: {
    updateNButtons() {
      //   var w = Math.round(window.innerWidth * 0.8);
      var w = window.innerWidth;
      if (w > 500) w = 500;
      var n = Math.floor((w - 61) / 94);
      //   this.nButtons = n * 2 - 1; // subtract 1 to save room for `more` button
      this.nButtons = n;
    },
    toggleShowAll() {
      this.showAll = !this.showAll;
    },
    openHelp() {
      this.log("open_help");
      setTimeout(() => this.contactFBMessengerSupport(), 500);
    },
    openLogisticsForm() {
      this.log("open_logistics");
      var url = this.$t("logistics.type-form-url");
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    openToursForm() {
      this.log("open_tours");
      var url = this.$t("tours.type-form-url"); // https://tukapp.typeform.com/to/c0ZK0Jnr
      setTimeout(() => window.open(url, "_blank"), 500);
    },
    goToShops() {
      this.gotoDelay("shop?tab=shops");
    },
    goToServices() {
      this.gotoDelay("shop?tab=services");
    },
  },
};
</script>

<style scoped>
.home-main-buttons-3 {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.more-btn {
  background-color: rgba(255, 255, 255, 0.3);
  color: #999;
}

.dark .more-btn {
  /* color: white; */
  color: var(--crypto-secondary);
}

.dark .more-btn:hover {
  background-color: black;
}

.all {
  /* position: absolute; */
  background-color: #ffc800;
  background-image: url("/img/home2/home-dots-pattern.png");
  background-size: cover;
  background-position: bottom;
  padding-top: 48px;
  padding-bottom: 14px;
  /* border-radius: 20px; */
  margin-left: -30px;
  padding-left: 30px;
  padding-right: 30px;
  width: calc(100% + 60px);
  margin-top: -48px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}

.dark .all {
  /* background-color: #959597; */
  background-color: var(--crypto-primary);
}

.btns {
  width: 100%;
  /* width: 80vw; */
  margin-top: 10px;
  padding-bottom: 10px;
  font-weight: 550;
  /* has-text-weight-bold */
  font-size: 0.85em;
  /* display: flex;
  flex-wrap: wrap;
  justify-content: space-between; */

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  justify-content: center;
  align-content: center;
  align-items: center;
  justify-items: center;
  gap: 6px;
  /* grid-auto-flow: column; */
  /* max-height: 60px;
  overflow: hidden; */
}

.bt {
  display: inline-block;
  margin-top: 10px;
  margin: 4px;
  padding: 5px;
  /* width: 80px; */
  width: 90px;
  background-color: rgba(255, 255, 255, 0.9);
  /* border-radius: 20px; */
  border-radius: 3px;
  /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.35); */
  /* box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.35); */
}

.ellipsis-wrapper {
  padding: 4px;
}

.ellipsis {
  padding: 0px;
  /* margin-top: 6px; */
  width: 50px;
}

.bt img {
  position: relative;
  /* height: 40px; */
  height: 50px;
  width: auto;
  z-index: 2;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.35));
  /* padding: 3px; */
}

.bt p {
  position: relative;
  z-index: 2;
  /* text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.35); */
}

.dark .bt {
  /* background-color: rgba(17, 34, 51, 0.8); */
  background-color: #1f1b24;
  color: white;
}

.right {
  position: absolute;
  right: 0px;
  top: 255px;
  padding: 0 7px;
}

.chevron {
  padding: 0px;
  width: 30px;
  height: 50px;
}

.chevron .fa {
  margin: auto;
  line-height: 50px;
}

.bt:active {
  transform: scaleY(0.95);
}

.single-line {
  text-overflow: hidden;
  white-space: nowrap;
}
</style>